import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PageBack from "../components/buttons/page-back";
import {db_tables, DBHelpers, rd, website, websites} from "../../vars/rd";
import {jsi} from "../../index";

class Setting extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        this.mounted = true;

        const db = await DBHelpers.openDB();
        const users = await db.select(db_tables.users, () => true) || {};
        if (this.mounted) this.setState({ users });
    }

    componentWillUnmount() {
        this.mounted = false;
        (async () => {
            try {
                if (this.state.users) {
                    const db = await DBHelpers.openDB();
                    await db.updateBulk(db_tables.users, this.state.users, (doc) => {
                        return doc.id === this.state.users.id;
                    });
                }
            } catch (e) {
                console.error('DB 저장 실패:', e);
            }
        })();
    }

    get use_mobile() {
        const users = this.state.users;
        if (users && users.use_mobile) {
            return users.use_mobile;
        }
        return 'N';
    }


    /**
     * 현재는 무조건 Y
     * @param e
     */
    // noinspection JSUnusedLocalSymbols
    toggleMobileData(e) {
        // this.setState({
        //     users: {...(this.state.users || {}), use_mobile: e.target.checked ? 'Y' : 'N'}
        // });

        this.setState(
            {
                users: {...(this.state.users || {}), use_mobile: 'Y'}
            }, async () => {
                const db = await DBHelpers.openDB();
                await db.updateBulk(db_tables.users, this.state.users, doc => {
                    return doc.id === this.state.users.id
                });
            }
        );
    }

    openBrowser(url) {
        jsi.jsi_open_browser(url);
    }

    render() {
        return (
            <div className="setup">
                <h2>
                    <PageBack />플레이어 설정
                </h2>
                <div className="setup-wrap">
                    <div className="item">
                        <div className="text-wrap">
                            <div className="text1">데이터 사용 설정</div>
                            <div className="text2">Wi-fi 연결이 끊길 경우 모바일 데이터 사용을 허용합니다.</div>
                        </div>
                        <div className="toggle">
                            <input type="checkbox" id="switch"
                                   onChange={e => this.toggleMobileData(e)}
                                   checked={this.use_mobile === 'Y'} />
                            <label htmlFor="switch">Toggle</label>
                        </div>
                    </div>
                    <div className="link-player">
                        <span>
                            플레이어 버전 1.0.0
                            <img src="/images/icon-link.png" alt={''} onClick={()=> this.openBrowser(website(websites.destination, {query: rd.user.websiteParameters("version")}))} />
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect()(withRouter(Setting));


// WEBPACK FOOTER //
// ./src/pages/setting/index.jsx